import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'notice-bar',
  setup(__props) {

const noticeList = ref([
  '🎉🎉🔥基于vue3.x 、Typescript、vite、Element plus等',
  '适配手机、平板、pc的后台开源免费模板库（vue2.x请切换vue-prev-admin分支）',
  '仓库地址：https://github.com/aigouzz/vue3-init-demos',
  '演示地址：https://aigouzz.github.io/demos'
])

return (_ctx: any,_cache: any) => {
  const _component_u_notice_bar = _resolveComponent("u-notice-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_u_notice_bar, { data: "🔥你是云层里隐约可见的星光，是银河里掉下来的一颗糖。" }),
    _createVNode(_component_u_notice_bar, {
      background: "#ecf5ff",
      color: "#409eff",
      "prefix-icon": "dianzan",
      "suffix-icon": "comment",
      data: "🔥生活本来就是不断失去的过程，你所失去的不过是换了另一种方式让你重新拥有。"
    }),
    _createVNode(_component_u_notice_bar, {
      vertical: "",
      data: noticeList.value
    }, null, 8, ["data"])
  ], 64))
}
}

})